import Modal from '@/shared/components/UI/Modal';
import Button from '@/shared/components/UI/Button';

interface RefundPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const RefundPolicyModal: React.FC<RefundPolicyModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <div className="text-left">
        <h2 className="mb-4 text-lg font-bold text-[#1D1D1D]">환불 정책</h2>

        <div className="max-h-[50vh] overflow-y-auto pr-2">
          <div className="text-sm text-[#1D1D1D]">
            <ul className="mb-4 list-disc space-y-2 pl-5">
              <li>
                반품, 교환 또는 환불 요청은 상품 수령 후 7일 이내에 K-MONSTAR
                고객 서비스를 통해 접수해야 합니다.
              </li>
              <li>7일 이후의 요청은 거절됩니다.</li>
              <li>
                원래의 배송비 또는 관세는 어떠한 경우에도 환불되지 않습니다.
              </li>
              <li>모든 요청은 요구사항을 충족할 때만 검토됩니다.</li>
              <li>
                K-MONSTAR는 언제든지 반품 또는 교환을 거부할 권리가 있습니다.
              </li>
            </ul>

            <h3 className="mb-2 text-base font-bold">환불 정책</h3>
            <ul className="mb-4 list-disc space-y-2 pl-5">
              <li>
                누락된 상품에 대한 환불 요청은 반드시 전체 각도에서 촬영된
                편집되지 않은 전체 언박싱 영상과 함께 제출되어야 합니다!
              </li>
              <li>
                케이스나 포장의 긁힘, 경미한 손상 및 변색은 제품 손상으로
                간주되지 않습니다.
              </li>
              <li>
                잘못되거나 불충분한 배송 주소로 인한 배송 실패의 경우 환불 또는
                재배송이 이루어지지 않습니다.
              </li>
              <li>
                누락되거나 손상된 제품 구성품(밀봉된 제품 내부)은 제품 언박싱
                영상으로만 조사될 수 있습니다.
              </li>
            </ul>

            <h3 className="mb-2 text-base font-bold">언박싱 영상 기준</h3>
            <ul className="mb-4 list-disc space-y-2 pl-5">
              <li>언박싱 영상은 모든 기준을 충족할 때만 유효합니다.</li>
              <li>
                모든 언박싱 영상은 100% 방해물 없이 모든 구성품이 카메라 앞에서
                제거되고 확인되는 과정을 보여야 합니다.
              </li>
              <li>
                언박싱 영상은 제품만을 보여주어야 하며 완전히 노출되어야 합니다.
              </li>
              <li>편집되거나 잘린 영상은 인정되지 않습니다.</li>
              <li>
                언박싱 영상은 새로 밀봉된 제품으로 촬영된 경우에만 유효합니다.
              </li>
            </ul>

            <p className="mb-4">
              오랫동안 기다린 상품을 받는 설렘을 100% 이해합니다. 하지만 국제
              배송 고객으로서 귀하의 권리를 보호하는 유일한 방법은 택배 개봉과
              제품 언박싱 영상을 촬영하는 것입니다. 귀하의 권리를 보장받기 위해
              언박싱 영상을 꼭 촬영해 주시기 바랍니다. 적절한 언박싱 영상이
              있어야만 저희가 소중한 고객님을 도와드릴 수 있습니다. 양해
              부탁드립니다.
            </p>

            <h3 className="mb-2 text-base font-bold">반품 정책</h3>
            <ul className="mb-4 list-disc space-y-2 pl-5">
              <li>
                반품 및 교환은 모든 원래 구성품과 함께 원래 포장으로 이루어져야
                합니다.
              </li>
              <li>반품 발송 전 K-MONSTAR의 승인을 받아야 합니다.</li>
              <li>
                반품 배송비는 상품이 누락되거나, 손상되었거나, 잘못된 경우에만
                K-MONSTAR가 부담합니다.
              </li>
              <li>
                K-MONSTAR는 반품 배송 중 발생하는 사고에 대해 책임지지 않습니다.
              </li>
            </ul>

            <h3 className="mb-2 text-base font-bold">주문 처리 / 취소</h3>
            <ul className="mb-4 list-disc space-y-2 pl-5">
              <li>
                영업일 기준 오전 10시(GMT+9) 이전 주문은 당일 처리 및
                포장됩니다.
              </li>
              <li>취소는 주문이 발송되기 전에만 가능합니다.</li>
            </ul>
          </div>
        </div>

        <div className="mt-6">
          <Button
            type="button"
            variant="primary"
            size="xs"
            onClick={onClose}
            fullWidth
          >
            Verify
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RefundPolicyModal;
